import moment from 'moment';
import DatePickerComponent from '../../../components/date-picker/date-picker.component';
import LocationTreeCheckboxComponent from '../../../components/location/location-tree-checkbox.component';
import MultiSelectComponent from '../../../components/multi-select/multi-select.component';
import SingleSelectComponent from "../../../components/single-select/single-select.component";
import paginationComponent from '../../../components/pagination/pagination.component';
import SelectSiteGroupComponent from '../../../components/site/select-site-group.component';
import SelectSiteSearchInputComponent from '../../../components/site/select-site-search-input.component';
import SelectUserComponent from '../../../components/user/select-user.component';
import { formats as FORMATS, codeMasterType } from '../../../config/constants';
import userSearchModal from '../../../models/common/user-search.modal';
import visitRateModel from '../../../models/schedule/visit-rate.modal';
import codeMasterModel from '../../../models/common/code-master.model';
import { exportRetailExcelTemplate } from '../../../models/file.model'
import ViewBase from '../../view-base.view';
import NumericWidgetView from './numeric-widgets.view';
import { Tooltip, PopoverPosition } from "construct-ui";

export default function VisitRateView() {
  ViewBase.call(this);

  const DEFAULT_INPUT_DATA = Object.freeze({
    data: Object.freeze([]),
    fromDate: moment().format(FORMATS.dateFormat),
    toDate: moment().format(FORMATS.dateFormat),
    selectedUsers: Object.freeze([]),
    selectedSiteGroups: Object.freeze([]),
    selectedSites: Object.freeze([]),
    selectedUserRoles: Object.freeze([]),
    selectedLocationList: Object.freeze([]),
    selectedStoreGrades: Object.freeze([]),
    pageIndex: 1,
    pageSize: 10,
    totalCount: 0,
    planStatus: "",
    total: 0,
    planned_total: 0,
    planned_completed: 0,
    planned_inprogress: 0,
    planned_notvisited: 0,
    unplanned_total: 0,
    colors: Object.freeze({
      total: "l-bg-blue-light",
      planned_total: "l-bg-white",
      planned_completed: "l-bg-white",
      planned_inprogress: "l-bg-white",
      planned_notvisited: "l-bg-white",
      unplanned_total: "l-bg-white"
    })
  });

  let outsideParams = null;
  let inputDataModel = _.cloneDeep(DEFAULT_INPUT_DATA);
  let userRoleOptionList = [];
  let BUList = [];
  let storeGrades = [];

  let extractFilterToQueryParams = () => {
    return Object.assign(
      {
        pageIndex: inputDataModel.pageIndex,
        pageSize: inputDataModel.pageSize,
        fromDate: moment(inputDataModel.fromDate, FORMATS.dateFormat).format(FORMATS.apiDateFormat),
        toDate: moment(inputDataModel.toDate, FORMATS.dateFormat).format(FORMATS.apiDateFormat)
      },
      _.isEmpty(inputDataModel.planStatus) ? null : { planStatus: inputDataModel.planStatus },
      _.isEmpty(inputDataModel.selectedUsers) ? null : { users: inputDataModel.selectedUsers.map(u => u.userID).join('^') },
      _.isEmpty(inputDataModel.selectedUserRoles) ? null : { userRoles: inputDataModel.selectedUserRoles.map(r => r.code).join('^') },
      _.isEmpty(inputDataModel.selectedSites) ? null : { sites: inputDataModel.selectedSites.map(r => r.siteId).join('^') },
      _.isEmpty(inputDataModel.selectedSiteGroups) ? null : { siteGroups: inputDataModel.selectedSiteGroups.map(g => g.code).join('^') },
      _.isEmpty(inputDataModel.selectedLocationList) ? null : { locations: inputDataModel.selectedLocationList.join('^') },
      _.isEmpty(inputDataModel.selectedStoreGrades) ? null : { storeGrades: inputDataModel.selectedStoreGrades.map(r => r.code).join('^') },
      _.isEmpty(inputDataModel.selectedBU) ? null : { bu: inputDataModel.selectedBU.code },
    );
  }

  const _clearFilter = () => {
    inputDataModel = _.cloneDeep(DEFAULT_INPUT_DATA);
    setupMadatoryFilterValue()
  }
  const getStoreGrades = () => {
    return codeMasterModel.getByCategoryV2({ category: codeMasterType.storeGrade })
      .then((result) => {
        if (result && result.length > 0) {
          result.map(i => {
            storeGrades.push({ code: i.code, name: i.name })
          })
        }
      })
      .catch((error) => {
        this.handleError(error);
      })
  }

  const _getUserRoleList = () => {
    userRoleOptionList = [];
    return userSearchModal.getUserRoleList(
      (result) => {
        if (result) {
          result.forEach(e => {
            userRoleOptionList.push({ ...e });
          });
        }
      },
      (error) => {
        this.handleError(error);
      }
    )
  }

  const validateForm = () => {
    let form = document.querySelector('.needs-validation');
    form.classList.add('was-validated');

    if (!form.checkValidity()) {
      return false
    }
    return true
  }

  let _search = () => {
    if (!validateForm()) {
      return Promise.reject({ message: "Invalid Form!" })
    }
    inputDataModel.pageIndex = 1;
    this.showLoading();
    Promise.allSettled([_getVisitSummaryRate(), _getVisitRateData()])
      .finally(() => { this.hideLoading() });
  }

  let _getVisitSummaryRate = () => {
    return visitRateModel.getVisitSummaryRate(extractFilterToQueryParams())
      .then((result) => {
        inputDataModel.total = Number(result["totalVisitPlan"]).toLocaleString('en-US');
        inputDataModel.planned_total = Number(result["plannedVisit"]).toLocaleString('en-US');
        inputDataModel.planned_completed = Number(result["completedVisit"]).toLocaleString('en-US');
        inputDataModel.planned_inprogress = Number(result["inProgressVisit"]).toLocaleString('en-US');
        inputDataModel.planned_notvisited = Number(result["notVisited"]).toLocaleString('en-US');
        inputDataModel.unplanned_total = Number(result["unplannedVisit"]).toLocaleString('en-US');
      })
      .catch((error) => {
        this.handleError(error);
      });
  }

  let _getVisitRateData = () => {
    if (!validateForm()) {
      return Promise.reject({ message: "Invalid Form!" })
    }
    return visitRateModel.getVisitRateData(extractFilterToQueryParams())
      .then((result) => {
        inputDataModel.data = result.data;
        inputDataModel.totalCount = result.total;
        inputDataModel.pageIndex = result.pageIndex;
        inputDataModel.pageSize = result.pageSize;
      })
      .catch((error) => {
        this.handleError(error);
      });
  }

  let _initControls = () => {
    this.showLoading();
    Promise.allSettled([_getVisitSummaryRate(), _getVisitRateData()])
      .finally(() => { this.hideLoading() })
  }

  const _downloadExcel = () => {
    this.showLoading();
    const requestParams = extractFilterToQueryParams()
    const fileName = 'Visit Plan List.xlsx';
    const exportConfig = {
      storedProcedureCode: "11",
      params: [
        { code: "8", value: requestParams.fromDate },
        { code: "9", value: requestParams.toDate },
        { code: "30", value: requestParams.siteGroups },
        { code: "31", value: requestParams.sites },
        { code: "32", value: requestParams.users },
        { code: "33", value: requestParams.planStatus },
        { code: "63", value: requestParams.userRoles },
        { code: "63",  value:requestParams.userRoles },
        { code: "157", value: requestParams.bu },
        { code: "160", value: requestParams.storeGrades},
        { code: "24", value: "" },
        { code: "2", value: "" },
        { code: "3", value: "0" },
        { code: "4", value: "0" }
      ],
      excelSheetNames: ["Visit Plan List", "Visit Plan Count"]
    };
    exportRetailExcelTemplate(exportConfig, fileName)
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  let onPageSizeChanged = (pageIndex, pageSize) => {
    inputDataModel.pageIndex = pageIndex;
    inputDataModel.pageSize = pageSize;
    this.showLoading();
    _getVisitRateData()
      .finally(() => { this.hideLoading() });
  }

  let onPageChanged = (pageIndex) => {
    inputDataModel.pageIndex = pageIndex;
    this.showLoading();
    _getVisitRateData()
      .finally(() => { this.hideLoading() });
  }

  let _onDatePickerChange = (e) => {
    inputDataModel.fromDate = moment(e.detail.start).format(FORMATS.dateFormat);
    inputDataModel.toDate = moment(e.detail.end).format(FORMATS.dateFormat);
  }

  let _changeDataSet = (planStatus) => {
    inputDataModel.planStatus = planStatus;
    inputDataModel.pageIndex = 1;
    this.showLoading();
    _getVisitRateData()
      .finally(() => { this.hideLoading() });
  }

  const formatDate = (time, unit, showSecs = true) => {
    const duration = moment.duration(time, unit);

    const hours = String(duration.hours()).padStart(2, '0');
    const minutes = String(duration.minutes()).padStart(2, '0');
    const secs = String(duration.seconds()).padStart(2, '0');
    let formatted
    if (showSecs) {
      formatted = `${hours}h : ${minutes}m : ${secs}s`;
    } else {
      formatted = `${hours}h : ${minutes}m`;
    }
    return formatted;
  }

  const setupMadatoryFilterValue = () => {
    inputDataModel.selectedStoreGrades = storeGrades;
    if (outsideParams && outsideParams.bu && outsideParams.bu.code) {
      inputDataModel.selectedBU = outsideParams.bu
    } else {
      inputDataModel.selectedBU = BUList[0];
    }
  }

  const setupFilter = () => {
    Promise.allSettled([_getUserRoleList(), getStoreGrades(), getBUInfo()])
      .then(() => {
        setupMadatoryFilterValue()
      })
    const params = m.route.param();
    if (params.fromDate) {
      inputDataModel.fromDate = moment(params.fromDate).format(FORMATS.dateFormat);
    }
    if (params.toDate) {
      inputDataModel.toDate = moment(params.toDate).format(FORMATS.dateFormat);
    }
    if (params.siteIDs && params.siteIDs.length > 0) {
      const siteIds = params.siteIDs.join(',');
      getSiteInfo(siteIds)
    }
    if (params.storeGrade) {
      inputDataModel.selectedStoreGrades = [{ name: params.storeGrade, code: params.storeGrade }]
    }
    if (params.supervisorIDs) {
      const { userID, userName } = params.supervisorIDs
      inputDataModel.selectedUsers = [{ userID: userID, userName: userName }]
    }
    if (params.bu && params.bu.code) {
      inputDataModel.selectedBU = { code: params.bu.code, name: params.bu.name };
    }
  }

  const getSiteInfo = (siteIds) => {
    const params = {
      // countryCode: loginModel.credentials.country,
      value: siteIds
    }
    codeMasterModel.searchByCategoryV2(codeMasterType.siteInfo, params)
      .then(result => {
        if (result && result.length > 0) {
          inputDataModel.selectedSites = result.map((v) => ({ siteId: v.code, siteName: v.name }));
        }
        _initControls();
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  const getBUInfo = () => {
    BUList = [];
    return codeMasterModel.getByCategoryV2({ category: 'JourneyPlanBU' })
      .then(result => {
        if (result && result.length > 0) {
          BUList = result;
        }
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  const handleGoBack = () => {
    window.history.back();
  }

  return {
    oninit: () => {
      outsideParams = m.route.param();
      setupFilter();
    },
    view: (vnode) => {
      return [
        m('.row',
          m('.col-12',
            outsideParams && outsideParams.supervisorIDs && outsideParams.supervisorIDs.userID && m('.col-12.d-flex.justify-content-start',
              m('a.icon-link.icon-link-hover.fw-semibold.fs-6', { onclick: handleGoBack, style: { cursor: 'pointer' } },
                m("i.bi.bi-arrow-left"),
                this.getText("LT00001205", "Go Back")
              ),
            ),
            // Search section
            m('.card.mb-3.mt-3',
              m('.card-body',
                m('form.row.g-4.needs-validation[novalidate]',
                  m('.col-md-3',
                    m('label.form-label', this.getText("LT00000070", "Date Range")),
                    m(DatePickerComponent, {
                      class: 'form-control',
                      isRange: true,
                      dateStart: inputDataModel.fromDate, // default date range
                      dateEnd: inputDataModel.toDate, // default date range
                      onselect: (e) => {
                        _onDatePickerChange(e);
                      }
                    })
                  ),
                  m('.col-md-3',
                    m('label.form-label', this.getText("LT00000072", "Site Group")),
                    m(SelectSiteGroupComponent, {
                      selectedItems: inputDataModel.selectedSiteGroups,
                      onChange: (g) => {
                        inputDataModel.selectedSiteGroups = g;
                      }
                    })
                  ),
                  m('.col-md-3',
                    m('label.form-label', this.getText("LT00000071", "Site")),
                    m(SelectSiteSearchInputComponent, {
                      id: 'sites',
                      multiple: true,
                      selectedItems: inputDataModel.selectedSites,
                      onSelect: (selectedItems) => {
                        inputDataModel.selectedSites = selectedItems;
                      }
                    })
                  ),
                  m('.col-md-3',
                    m('label.form-label', this.getText("LT00000009", "User")),
                    m(SelectUserComponent, {
                      default: {
                        userStatusCode: '0001'
                      },
                      onSelect: (u) => {
                        inputDataModel.selectedUsers = u;
                      },
                      selectedUserList: inputDataModel.selectedUsers,
                    })
                  ),
                  m('.col-md-3',
                    m('label.form-label', this.getText("LT00000060", "User Role")),
                    m(MultiSelectComponent, {
                      items: userRoleOptionList,
                      selectedItems: inputDataModel.selectedUserRoles,
                      onSelect: (s) => {
                        inputDataModel.selectedUserRoles = s;
                      }
                    }),
                  ),
                  m('.col-md-3',
                    m('label.form-label[for=locations]', this.getText('LT00000557', 'Location')),
                    m(LocationTreeCheckboxComponent, {
                      id: 'locations',
                      selectedCodes: inputDataModel.selectedLocationList,
                      isLevel1Expanded: true,
                      onChange: (value) => {
                        inputDataModel.selectedLocationList = value;
                      }
                    })
                  ),
                  m('.col-md-3.position-relative',
                    m('label.form-label[for=storeGrades].mandatory', this.getText("", "Store Grade")),
                    m(MultiSelectComponent, {
                      id: 'storeGrades',
                      allowEmpty: true,
                      required: true,
                      items: storeGrades,
                      selectedItems: inputDataModel.selectedStoreGrades,
                      onSelect: (s) => {
                        inputDataModel.selectedStoreGrades = s;
                      }
                    }),
                    m('.invalid-tooltip', this.getText("LT00000201", "Please select"))
                  ),
                  m('.col-md-3.position-relative',
                    m('label.form-label[for=BU].mandatory', this.getText("LT00000817", "IM/CE Store")),
                    m(SingleSelectComponent, {
                      id: 'BU',
                      allowEmpty: false,
                      required: true,
                      items: BUList,
                      selectedItem: inputDataModel.selectedBU,
                      filterable: false,
                      onSelect: (s) => {
                        inputDataModel.selectedBU = s;
                      }
                    }),
                    m('.invalid-tooltip', this.getText("LT00000201", "Please select"))
                  ),
                  m('.col-12.gap-2.d-flex.justify-content-end',
                    m('button.btn.btn-primary', { onclick: _search }, this.getText("LT00000001", "Search")),
                    m('button.btn.btn-white', { onclick: _clearFilter }, this.getText("LT00000031", "Clear")),
                  ),
                )
              )
            ),

            // Filter section
            m('.row.mb-3',
              m(NumericWidgetView, { onClick: _changeDataSet, data: inputDataModel })
            ),

            // Table
            m('.card',
              m('.card-body',
                m('.d-flex.justify-content-end.mb-2',
                  m('a.btn.btn-primary', { onclick: _downloadExcel },
                    m('i.bi.bi-file-earmark-arrow-down-fill'), this.getText("LT00000018", "Excel Download"),
                  )
                ),
                m('.row',
                  m(".col-12.p-0",
                    m(".table-responsive",
                      m("table.table.align-middle.table-bordered",
                        [
                          m("thead.thead-bggrey",
                            m("tr.align-middle", { style: 'box-shadow: 0px 1px var(--blue-color-light)' }, [
                              m("th", { "scope": "col", "colspan": "3" }),
                              m("th", { "scope": "col", "colspan": "5", "style": "text-align :center;" }, "Planned"),
                              m("th", { "scope": "col", "colspan": "4", "style": "text-align :center;" }, "Actual"),
                              m("th", { "scope": "col", "colspan": "2" }),
                            ]),
                            m("tr", [
                              m("th", { "scope": "col" }, this.getText("LT00000009", "User")),
                              m("th", { "scope": "col" }, this.getText("LT00000169", "Store")),
                              m("th", { "scope": "col" }, this.getText("LT00008092", "Grade")),
                              m("th", { "scope": "col" }, this.getText("LT00000132", "Date")),
                              m("th", { "scope": "col" }, this.getText("LT00000170", "Start Time")),
                              m("th", { "scope": "col" }, this.getText("LT00000171", "End Time")),
                              m("th", { "scope": "col" }, this.getText("LT00008106", "Travel Time")),
                              m("th", { "scope": "col" }, this.getText("LT00008107", "Dwell Time")),
                              m("th", { "scope": "col" }, this.getText("LT00000172", "Check-in Time")),
                              m("th", { "scope": "col" }, this.getText("LT00000173", "Check-out Time")),
                              m("th", { "scope": "col" }, this.getText("LT00008106", "Travel Time")),
                              m("th", { "scope": "col" }, this.getText("LT00008107", "Dwell Time")),
                              m("th", { "scope": "col" }, this.getText("LT00000174", "Visit Plan Type")),
                              m("th", { "scope": "col" }, this.getText("LT00000175", "Visit Status"))
                            ])
                          ),
                          m("tbody",
                            inputDataModel.data.length == 0 &&
                            m("tr",
                              m("td", { "colspan": "9" }, this.getText("EM00000141", "No records found."))
                            ),
                            inputDataModel.data.map(gc => [
                              m("tr",
                                [
                                  m("td", { style: "white-space: initial;" },
                                    // gc.photoString != "" ? m('img.userImg-circle[src=' + gc.photoString + ']') : 
                                    // m('img.userImg-circle[src=' + staticUrls.emptyUserImage + ']'),
                                    gc.userName),
                                  m("td", { style: "display: inline-block; border: none; max-width: 400px; min-width: 200px; width: auto; white-space: initial;" }, `[#${gc.siteId}] ${gc.siteName}`),
                                  m("td", gc.grade),
                                  m("td", m(Tooltip, {
                                    content: m('span', gc.scheduleSource && gc.scheduleSource === "JPOSchedule" ? "Scheduled by JPO" : gc.scheduleSource === 'ManualSchedule' && "Scheduled by team"),
                                    hoverOpenDelay: 250,
                                    openOnTriggerFocus: true,
                                    position: PopoverPosition.AUTO,
                                    trigger: m('span', gc.scheduleSource && gc.scheduleSource === "JPOSchedule" ?
                                      m("i", { "class": "bi bi-journal-text", style: { color: '#69c506' } }) :
                                      gc.scheduleSource === 'ManualSchedule' && m("i", { "class": "bi bi-people", style: { color: '#ec9b21' } }), m("span", { style: { color: gc.scheduleSource === "JPOSchedule" ? '#69c506' : '#ec9b21' } }, gc.scheduleDate))
                                  })),
                                  m("td", gc.startTime),
                                  m("td", gc.endTime),
                                  m("td", gc.planTravelingTime ? formatDate(gc.planTravelingTime, 'seconds', true) : ""),
                                  m("td", gc.planDwellTime ? formatDate(gc.planDwellTime, 'minutes', false) : ""),
                                  m("td", m(Tooltip, {
                                    content: m('span', gc.checkInSource && gc.checkInSource === "Mobile" ? "Check in via Mobile" : gc.checkInSource === 'Upload' && "Check in via Admin"),
                                    hoverOpenDelay: 250,
                                    openOnTriggerFocus: true,
                                    position: PopoverPosition.AUTO,
                                    trigger: m('span', gc.checkInSource && gc.checkInSource === "Mobile" ? m("i", { "class": "bi bi-phone" }) : gc.checkInSource === 'Upload' && m("i", { "class": "bi bi-person" }), gc.checkInTime)
                                  })),
                                  m("td",
                                    m(Tooltip, {
                                      content: m('span', gc.checkOutSource && gc.checkOutSource === "Mobile" ? "Check out via Mobile" : gc.checkOutSource === 'Upload' && "Check out via Admin"),
                                      hoverOpenDelay: 250,
                                      openOnTriggerFocus: true,
                                      position: PopoverPosition.AUTO,
                                      trigger: m('span', gc.checkOutSource && gc.checkOutSource === "Mobile" ? m("i", { "class": "bi bi-phone" }) : gc.checkOutSource === 'Upload' && m("i", { "class": "bi bi-person" }), gc.checkOutTime)
                                    })),
                                  m("td", gc.actualTravelingTime ? formatDate(gc.actualTravelingTime, 'seconds', true) : ""),
                                  m("td", gc.actualDwellTime ? formatDate(gc.actualDwellTime, 'minutes', false) : ""),
                                  m("td", gc.scheduleType == "PlannedVisit" && m('.badge.rounded-pill.grey-bg-status', gc.scheduleType),
                                    gc.scheduleType == "UnplannedVisit" && m('.badge.rounded-pill.expired-bg-status', gc.scheduleType)),
                                  m("td", gc.visitStatus == "Completed" && m('.badge.rounded-pill.green-bg-status', gc.visitStatus),
                                    gc.visitStatus == "In Progress" && m('.badge.rounded-pill.pending-bg-status', gc.visitStatus),
                                    gc.visitStatus == "Not Visited" && m('.badge.rounded-pill.danger-bg-status', gc.visitStatus))
                                ]
                              )
                            ]),
                          )
                        ]
                      ),
                    ),
                    !this._isLoading &&
                    m(".px-3",
                      m(paginationComponent, { currentPage: inputDataModel.pageIndex, pageSize: inputDataModel.pageSize, totalItems: inputDataModel.totalCount, onPageChanged: onPageChanged, onPageSizeChanged: onPageSizeChanged })
                    )
                  )
                )
              ),
            )
          )
        ),
        this.getBaseViews()
      ]
    }
  }
}
